import React, {
    MutableRefObject,
    ReactChild,
    useEffect,
    useState,
} from 'react';

import Player from 'video.js/dist/types/player';

import {
    Box,
    Dialog,
    DialogContent,
    IconButton,
    Typography,
} from '@mui/material';
import RefreshIcon from '@mui/icons-material/Refresh';

import TranslationHelper from '../../../helpers/TranslationHelper';
import SinglePlayer from './components/SinglePlayer';
import AllCameras from './components/AllCameras';
import { isPlayerEnabled } from '../../../helpers/isPlayerEnabled';
import useToggle from '../../../hooks/useToggle';
import LoadingSpinner from '@/app/components/loadingSpinner/LoadingSpinner';

export const ALL_CAMERAS_ID = 'allCameras';

interface IOwnProps {
    getSrcUrl: ((paramName: string) => string) | null;
    videoRef: MutableRefObject<HTMLVideoElement | null>;
    open: boolean;
    handleClose: () => void;
    children: ReactChild;
    type: string;
    selectedCamera: string;
    ids: string[];
}

const VideoPlayerDialog = ({
    getSrcUrl,
    videoRef,
    open,
    handleClose,
    children,
    type,
    selectedCamera,
    ids,
}: IOwnProps) => {
    const [error, setError] = useState(false);
    const [vertical, setVertical] = useState(false);
    const playerRef = React.useRef<Player | null>(null);
    const showPlayer = isPlayerEnabled();
    const { isOpen: fullscreen, handleToggle } = useToggle(false);
    useEffect(() => {
        if (!showPlayer) {
            handleClose();
        }
    }, [showPlayer]);

    const handleError = () => {
        setError(true);
    };

    const resetData = () => {
        setError(false);
    };

    const handleOrientation = (vertical: boolean) => {
        setVertical(vertical);
    };
    const renderContent = () => {
        if (error) {
            return (
                <Box
                    sx={{
                        width: '100%',
                        height: 300,
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center',
                        alignItems: 'center',
                        backgroundColor: 'black',
                    }}
                >
                    <Typography>
                        {TranslationHelper.translate(
                            'The video cannot be played'
                        )}
                    </Typography>
                    <IconButton onClick={resetData} sx={{ color: 'white' }}>
                        <RefreshIcon />
                    </IconButton>
                </Box>
            );
        }
        if (selectedCamera === ALL_CAMERAS_ID) {
            return (
                <AllCameras
                    // @ts-ignore
                    getSrcUrl={getSrcUrl}
                    ids={ids}
                    videoRef={videoRef}
                    fullscreen={fullscreen}
                    handleFullscreen={handleToggle}
                    type={type}
                />
            );
        }
        return (
            <SinglePlayer
                // @ts-ignore
                videoSrc={getSrcUrl(selectedCamera)}
                videoRef={videoRef}
                playerRef={playerRef}
                handleError={handleError}
                handleOrientation={handleOrientation}
                type={type}
            />
        );
    };
    return (
        <Dialog
            open={open}
            onClose={handleClose}
            maxWidth={'lg'}
            fullWidth={!vertical}
            fullScreen={fullscreen}
        >
            {children}
            <DialogContent
                sx={{
                    '.MuiDialogContent-root&.MuiDialogContent-root': { p: 0.2 },
                    backgroundColor: 'black',
                }}
            >
                {getSrcUrl ? (
                    renderContent()
                ) : (
                    <Box
                        sx={{
                            width: '100%',
                            height: 300,
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'center',
                            alignItems: 'center',
                            backgroundColor: 'black',
                        }}
                    >
                        <LoadingSpinner opacity={'0'} />
                    </Box>
                )}
            </DialogContent>
        </Dialog>
    );
};

export default VideoPlayerDialog;
